import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SmsTextareaComponent } from '@modules/sms/components/sms-textarea/sms-textarea.component';
import { TextareaComponent } from '@modules/sms/components/templates/textarea/textarea.component';
import { SmsTemplateCreateEditModalComponent } from '@modules/sms/templates/create-edit-modal/sms-template-create-edit-modal.component';
import { SmsTemplatePreviewModalComponent } from '@modules/sms/templates/sms-template-preview-modal/sms-template-preview-modal.component';
import { ClickStatisticsComponent } from '@modules/statistics/rich-sms-details/click-statistics/click-statistics.component';
import { DeviceStatisticsComponent } from '@modules/statistics/rich-sms-details/device-statistics/device-statistics.component';
import { NgbDropdownModule, NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderService } from '@services/loader.service';
import { UiModule } from '@ui/ui.module';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { provideCharts, withDefaultRegisterables, BaseChartDirective } from 'ng2-charts';
// import { ToastrModule } from 'ngx-toastr';
// import { ColorPickerDirective } from 'ngx-color-picker';
import { ContactsListComponent } from './views/contacts/contacts-list/contacts-list.component';
import { ContactsGroupsComponent } from './views/contacts/groups/groups.component';
import { CreditsAlertComponent } from './views/credits-alert/credits-alert.component';
import { TemplateComponent } from './views/email/template/template.component';

const MODULES = [
  NgbNavModule,
  MatTooltipModule,
  MatSlideToggleModule,
  MatNativeDateModule,
  OverlayModule,
  FormsModule,
  NgbDropdownModule,
  CKEditorModule,
  UiModule,
  // BaseChartDirective,
  // ToastrModule,
  NgSelectModule,
  NgbModule,
  ReactiveFormsModule,
  FontAwesomeModule,
  // ColorPickerDirective,
  CommonModule
];

const COMPONENTS = [
  ContactsListComponent,
  ContactsGroupsComponent,
  TemplateComponent,
  SmsTemplatePreviewModalComponent,
  SmsTextareaComponent,
  ClickStatisticsComponent,
  DeviceStatisticsComponent,
  SmsTemplateCreateEditModalComponent,
  TextareaComponent,
  CreditsAlertComponent
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    ...MODULES,
    TranslateModule.forChild({
      extend: true
    }),
    InlineSVGModule.forRoot(),
    BaseChartDirective
  ],
  exports: [...MODULES, ...COMPONENTS, BaseChartDirective],
  providers: [provideCharts(withDefaultRegisterables()), LoaderService]
})
export class AppSharedModule {}
